import React,{Component} from 'react'
import { message, Input, Select, Icon, Popover, Button, Checkbox, Alert, notification } from 'antd'

import { Link }   from 'react-router-dom'
import classnames from "classnames"

import CloudFlyerAPI from '../../../api/CloudFlyerAPI'
import InfoBulb   from '../../../components/Shared/InfoBulb'

import './styles.scss'

export default class AddBucket extends Component {

  wasabiBucketNameInfo = 'The bucket name must be unique across all existing bucket names in Wasabi.'
  awsBucketNameInfo = 'The bucket name must be unique across all existing bucket names in Amazon S3. Buckets used as an origin point for Amazon Cloudfront distribution have specific restrictions.'

  constructor(props) {
    super(props)

    this.state = {
      bucket : {
        bucket_name   : '',
        region        : 'us-east-1',
        account_type  : props.match.params.provider ? props.match.params.provider : 'aws',
        config_bucket : 'None',

        users : [
          /*{
            user: '',
            permissions:{
              READ      : false,
              WRITE     : false,

              READ_ACP  : false,
              WRITE_ACP : false
            }
          }*/
        ],

        public: {
          permissions:{
            READ : false
          }
        },

        system: {
          permissions:{
            READ : false
          }
        }
      },

      cloud : props.match.params,

      regions : [
        'us-east-1',
        'us-east-2',
        'us-west-1',
        'us-west-2',
        'ca-central-1',
        'ap-south-1',
        'ap-northeast-2',
        'ap-southeast-1',
        'ap-southeast-2',
        'ap-northeast-1',
        'eu-central-1',
        'eu-west-1',
        'eu-west-2',
        'eu-west-3',
        'sa-east-1',
        'cn-north-1',
        'cn-northwest-1'
      ],

      wasabi_regions : [
        'us-east-1',
        'us-west-1',
        'eu-central-1'
      ],

      storages :[],

      permissions:{
        public_:{
          selected:'false',
          all:[
            {
              label:'Do not grant public read access to this bucket',
              acl:'false'
            },
            {
              label:'Grant public read access to this bucket',
              acl:'true'
            }
          ]
        },

        system:{
          selected:'false',
          all:[
            {
              label:'Do not grant Amazon S3 Log Delivery group write access to this bucket',
              acl:'false'
            },
            {
              label:'Grant Amazon S3 Log Delivery group write access to this bucket',
              acl:'true'
            }
          ]
        }
      },

      inputs:{
        new_user: '',
        permissions:{
          READ      : false,
          WRITE     : false,

          READ_ACP  : false,
          WRITE_ACP : false
        },

        iam_users:[],
      },

      feeds:{
        users:[
          /*{
            arn: "arn:aws:iam::813264932086:user/CloudFlyer",
            create_date:"2017-05-31T22:15:40.000Z",
            password_last_used:"2017-06-29T10:07:24.000Z",
            path:"/",
            user_id: "AIDAJKQZ5G223HY6N6LN2",
            user_name:"CloudFlyer"
          }*/
        ]
      },

      add_user_visible : false,
      loading:false,
      error:'',
      description:''
    }
    this.state = { ...this.state, isWasabi: this.state.bucket.account_type === 'wasabi' }
  }

  componentDidMount(){
    this.refresh()
  }

  refresh = ()=>{
    let $this = this
    CloudFlyerAPI.cloud_accounts
      .buckets(this.state.cloud.id)
      .then(res=> $this.setState({storages:[{bucket_name:'None'}, ...((res||{}).data||{})]}))
      .then(()=> CloudFlyerAPI.cloud_accounts.users($this.state.cloud.id))
      .then(res=>{
        let {feeds} = $this.state
        feeds.users = ((res||{}).data||{})
        $this.setState({feeds})
      })
      .catch(err=> this.setState({error:(((((err||{}).response||{}).data)||{}).errors||[])[0]}))
  }

  on_bucket_change = e => {
    const { name, value } = e.target||e||{}
    this.setState({bucket:{...this.state.bucket, ...{[name]:value}}}, ()=> name === 'bucket_name' ? this.validate_bucket_name(value) : '')
  }

  on_input_change = e => {
    if(this.state.feeds.users.length>0){
      console.log(e)
      //this.setState({bucket:{...this.state.inputs, ...{[name]:value}}})
    } else {
      const { name, value } = e.target||e||{}
      this.setState({bucket:{...this.state.inputs, ...{[name]:value}}})
    }
  }

  on_permission_change = (type, value) =>{
    let permissions            = this.state.permissions
    permissions[type].selected = value
    this.setState({permissions:permissions})
  }

  on_add_user_visible_change = value =>{
    if(!this.state.add_user_visible){
      let {inputs} = this.state
      inputs = {...inputs, ...{iam_users:[], new_user:'', permissions:{
            READ      : false,
            WRITE     : false,

            READ_ACP  : false,
            WRITE_ACP : false
          }}}
      this.setState({add_user_visible:!this.state.add_user_visible, inputs})
    } else if(value){
      this.setState({add_user_visible:false})
    }
  }

  on_add_user_input_change = e => {
    if(this.state.feeds.users.length>0){
      this.setState({inputs:{...this.state.inputs, ...{['iam_users']:e}}})
    } else {
      const { name, value } = e.target||e||{}
      this.setState({inputs:{...this.state.inputs, ...{[name]:value}}})
    }
  }

  on_save_user = () =>{
    let {inputs, feeds} = this.state
    let bucket = this.state.bucket

    let users = inputs.iam_users.map(user_id=>({
      user: (feeds.users.filter(u=> u.user_id === user_id)[0]||{}).user_name,
      permissions:inputs.permissions
    }))

    for (let key in users){
      if(!(bucket.users.filter(u=> u.user === users[key].user)[0]))
        bucket.users.push(users[key])
    }

    if(inputs.new_user && !(bucket.users.filter(u=> u.user === inputs.new_user)[0])){
      bucket.users.push({
        user: inputs.new_user,
        permissions:inputs.permissions
      })
    }
    this.setState({bucket, add_user_visible:false})
  }

  on_remove_user = user =>{
    let bucket = this.state.bucket
    bucket.users = bucket.users.filter(u=> u.user !== user.user)
    this.setState({bucket})
  }

  on_permission_select = (name, value) =>{
    let {inputs} = this.state
    inputs.permissions[name] = value
    this.setState({inputs})
  }

  create_bucket = () =>{
    let { bucket:body, permissions } = this.state
    body = {...body}

    if(body.config_bucket === 'None')
      body.config_bucket =''
    body.public.permissions.READ = permissions.public_.selected
    body.system.permissions.READ = permissions.system.selected

    this.setState({loading: true})
    const { history } = this.props

    let $this = this
    CloudFlyerAPI
      .storages
      .create(this.state.cloud.id, body)
      .then(()=>{
        message.success(body.bucket_name + ' created successfully, Please allow just a little time for us to aggregate.')
        notification.success('Please allow just a little time for us to aggregate ' + body.bucket_name + ' data.')
        history.push('/')
      })
      .catch(err=>{
        console.error(err)

        if(((err.response||{}).data||{}) && ((err.response||{}).data||{}).errors && ((err.response||{}).data||{}).errors.length >0){
          $this.setState({error:(err.message||'Error'), description:((err.response||{}).data||{}).errors[0], loading:false})
        } else {
          $this.setState({description:(err.message||'Error'), loading:false})
        }
      })
  }

  validate_bucket_name = bucket_name =>{
    let validate_errors = this.is_valid_bucket_name(bucket_name)
    if(validate_errors && validate_errors.length > 0)
      return this.setState({bucket_name_error:validate_errors[0]})

    let $this = this
    CloudFlyerAPI
      .cloud_accounts
      .validate_bucket_name(this.state.cloud.id, bucket_name, this.state.cloud.provider)
      .then(()=> $this.setState({bucket_name_error:''}))
      .catch(err=>{
        console.dir(err)

        if(((err.response||{}).data||{}) && ((err.response||{}).data||{}).errors && ((err.response||{}).data||{}).errors.length >0){
          $this.setState({bucket_name_error:((err.response||{}).data||{}).errors[0]})
        } else {
          $this.setState({bucket_name_error:(((err.response||{}).data||{}).message || 'Bucket with same name exist')})
        }
      })
  }

  is_valid_bucket_name = bucket_name => {
    let errors = []
    try {
      if(!bucket_name){
        errors.push("Bucket name must not be empty")
        return errors
      }
      let key = "\0";
      let I = "";
      for (let i = 0; i < bucket_name.length; i++) {
        let F = bucket_name.charAt(i);
        let H = "";
        if (/[A-Z]/.test(F)) {
          let error = "Bucket name must not contain uppercase characters"
          if (errors.indexOf(error) === -1) {
            errors.push(error)
          }
        }
        if (F === ".") {
          if (key === "\0") {
            H = "Bucket name must start with a lowercase letter or number"
          }
          if (key === ".") {
            H = "Bucket name must not contain two adjacent periods"
          }
          if (key === "-") {
            H = "Bucket name must not contain dash next to period"
          }
        } else {
          if (F === "-") {
            if (key === "\0") {
              H = "Bucket name must start with a lowercase letter or number"
            }
            if (key === ".") {
              H = "Bucket name must not contain dash next to period"
            }
          } else {
            if (!/[a-z0-9]/.test(F) && I.indexOf(F) === -1) {
              if (!/[A-Z]/.test(F)) {
                I += F
              }
              if (key === "\0") {
                H = "Bucket name must start with a lowercase letter or number"
              }
            }
          }
        }
        if (H && errors.indexOf(H) === -1) {
          errors.push(H)
        }
        key = F
      }
      if (key === "." || key === "-") {
        errors.push("Bucket name must not end with dash or period")
      }
      if (I.length > 0) {
        errors.push("Bucket name contains invalid characters" + " '" + I + "'")
      }
      if (bucket_name.length < 3 || bucket_name.length > 63) {
        errors.push("Bucket name must be between 3 and 63 characters long")
      }
      if (/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(bucket_name)) {
        errors.push("Bucket name must not resemble an IP address")
      }
      return errors
    } catch (e) {}

    return errors
  }

  render() {
    const {inputs={}, feeds={}, loading, bucket_name_error, error, description, bucket, wasabi_regions, regions, storages, add_user_visible, isWasabi } = this.state||{}
    const {bucket_name, region, config_bucket, users:bucket_users} = bucket||{}
    const {public_, system}                                        = this.state.permissions||{}
    const {iam_users=[], permissions:user_permissions, new_user}   = inputs||{}
    const {users=[]}                                               = feeds||{}
    return (
      <div className='add-bucket'>
        <div className='header'>
          <h2>Create New Bucket</h2>
          <h2>
            <Link to="/">Cancel</Link>
          </h2>
        </div>

        {
          (description||error) ?
            <div className={'error-banner'}>
              <Alert description={description||error} type="error" closeText="Close Now"/>
            </div>:null
        }

        <div className='step'>
          <h3 className='step-header'><span>1</span>Name</h3>
          <div className={'step-row'}>
            <div className={'user-input'}>
              <label>Bucket Name  <InfoBulb info={isWasabi ? this.wasabiBucketNameInfo : this.awsBucketNameInfo} /></label>
              <Input
                placeholder='Enter DNS-compliant bucket name' name='bucket_name' value={bucket_name}
                className={classnames({ 'required': !bucket_name })}
                onChange={this.on_bucket_change} autoFocus/>
              {(!bucket_name || bucket_name_error) && <span className='required'>{bucket_name_error || 'Name is required.'}</span>}
            </div>

            <div className={'user-input'}>
              <label>Region <InfoBulb info="Region for the bucket"/></label>
              <Select value={region}
                dropdownMatchSelectWidth={false}
                onChange={e => this.on_bucket_change({ name: 'region', value: e })}
                placeholder={'Select bucket'}>
                {(() => {
                  // enable only us-east-1 region on wasabi
                  //const disabled = isWasabi
                  return (isWasabi ? wasabi_regions: regions ).map((s, i) =>
                    <Select.Option key={s} value={s}>{s}</Select.Option>
                  )
                })()}
              </Select>
            </div>
          </div>

          <div className={'step-row'}>
            <div className={'user-input'}>
              <label style={isWasabi ? { opacity: .6}: {}}>
                Copy settings from an existing bucket <InfoBulb info="Select bucket (optional)"/>
              </label>
              <Select
                disabled={isWasabi}
                value={config_bucket}
                dropdownMatchSelectWidth={false}
                onChange={e => this.on_bucket_change({ name: 'config_bucket', value: e })}
                placeholder={'Select bucket (optional)'}>{
                  storages.map(s => <Select.Option key={s.bucket_name}>{s.bucket_name}</Select.Option>)
                }
              </Select>
            </div>
          </div>
        </div>

        {
          !isWasabi &&
        <div className='step'>
          <h3 className='step-header'><span>2</span>Manage Users</h3>

          <div className={'users'}>{
            bucket_users.map((user, index) =>
              <div className='item columnWrap' key={index}>
                <Icon type="user" />
                <div>
                  <span>{user.user} </span>
                  {
                    (user.permissions.READ || user.permissions.WRITE) ?
                      <div className={'properties'}>
                        <span>Object Access:</span>
                        {
                          user.permissions.READ ?
                            <span className={'read'}> READ</span>:null
                        }
                        {
                          user.permissions.WRITE ?
                            <span className={'write'}> WRITE</span>:null
                        }
                      </div> : null
                  }

                  {
                    (user.permissions.READ_ACP || user.permissions.WRITE_ACP) ?
                      <div className={'properties'}>
                        <span>Permission Access:</span>
                        {
                          user.permissions.READ_ACP ?
                            <span className={'read'}> READ</span>:null
                        }
                        {
                          user.permissions.WRITE_ACP ?
                            <span className={'write'}> WRITE</span>:null
                        }
                      </div>
                      :null
                  }
                </div>
                <Icon type="close" onClick={()=> this.on_remove_user(user)}/>
              </div>
            )
          }

            <Popover title="Add User and Permissions"
                     trigger="click"
                     placement="topRight"
                     overlayClassName={'add-user-popover'}
                     visible={add_user_visible}
                     onVisibleChange={()=> this.on_add_user_visible_change()}
                     content={(
                       <div className={'controls'}>
                         {
                           users.length ?
                             <Select
                               mode='multiple'
                               value={iam_users}
                               name='new_user'
                               filterOption={false}
                               placeholder='Enter an ID or an email address'
                               dropdownMatchSelectWidth={false}
                               size={'large'}
                               onChange={this.on_add_user_input_change} autoFocus>
                               {users.map(d=><Select.Option key={d.user_id}>{d.user_name}</Select.Option>)}
                             </Select> :
                             <div className={'user-input'}>
                               <label>AWS ID or email <InfoBulb info="Enter an ID or an email address"/></label>
                               <Input placeholder='Enter an ID or an email address' name='new_user' value={new_user}
                                      onChange={this.on_add_user_input_change} autoFocus/>
                             </div>
                         }

                         <div className={'user-input'}>
                           <label>Object Access <InfoBulb info=""/></label>

                           <div>
                             <Checkbox checked={user_permissions.READ} onChange={(e)=> this.on_permission_select('READ', e.target.checked)}>READ</Checkbox>
                             <Checkbox checked={user_permissions.WRITE} onChange={(e)=> this.on_permission_select('WRITE', e.target.checked)}>WRITE</Checkbox>
                           </div>
                         </div>

                         <div className={'user-input'}>
                           <label>Permission Access <InfoBulb info=""/></label>

                           <div>
                             <Checkbox checked={user_permissions.READ_ACP} onChange={(e)=> this.on_permission_select('READ_ACP', e.target.checked)}>READ</Checkbox>
                             <Checkbox checked={user_permissions.WRITE_ACP} onChange={(e)=> this.on_permission_select('WRITE_ACP', e.target.checked)}>WRITE</Checkbox>
                           </div>
                         </div>

                         <div className={'popover-controls'}>
                           <Button onClick={()=> this.on_add_user_visible_change(true)} size={'small'}>
                             cancel
                           </Button>
                           <Button onClick={()=> this.on_save_user()} size={'small'} disabled={
                             (!iam_users.length && !new_user) || !(user_permissions.READ || user_permissions.WRITE || user_permissions.READ_ACP || user_permissions.WRITE_ACP)
                             }>
                             <Icon type="plus" />save
                           </Button>
                         </div>
                       </div>
                     )}>

              <Button className={'add'} onClick={()=>this.on_add_user_visible_change()} size={'small'}>
                <Icon type="plus" />add {users.length > 0?'More' :''} Users
              </Button>
            </Popover>

          </div>
        </div>
        }

        <div className='step'>
          <h3 className='step-header'>
            <span>{isWasabi ? 2 : 3}</span> Permissions
          </h3>
          <div className={'step-row'}>

            <div className={'user-input'}>
              <label>Manage public permissions <InfoBulb info="Manage public permissions"/></label>
              <Select
                value      ={public_.selected} dropdownMatchSelectWidth={false}
                onChange   ={e=> this.on_permission_change('public_', e)}
                placeholder={'Manage public permissions'}>{public_.all.map(s =><Select.Option key={s.acl}>{s.label}</Select.Option>)}
              </Select>
            </div>
            {
              !isWasabi &&
              <div className={'user-input'}>
                <label>Manage system permissions <InfoBulb info="Manage system permissions" /></label>
                <Select
                  value={system.selected} dropdownMatchSelectWidth={false}
                  onChange={e => this.on_permission_change('system', e)}
                  placeholder={'Manage system permissions'}>{
                    system.all.map(s => <Select.Option key={s.acl}>{s.label}</Select.Option>)
                  }
                </Select>
              </div>
            }
          </div>
        </div>

        <div className="footer">
          <Button
            type="primary"
            disabled={loading || !bucket_name || !region}
            loading={loading}
            onClick={this.create_bucket}>
            Create Bucket
          </Button>
        </div>
      </div>
    )
  }
}
